import { useEffect, useRef } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(window.location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    const finish = () => {
      window.location.replace("/admin");
    };
    if (!sessionId) {
      finish();
      return;
    }
    fetch(`${API}/auth/session`, {
      method: "POST",
      headers: { "X-Session-ID": sessionId },
      credentials: "include",
    })
      .then(() => finish())
      .catch(() => finish());
  }, []);

  return (
    <div className="relative z-10 min-h-screen flex items-center justify-center text-[#A59DAB]">
      <p className="font-heading italic text-2xl">Signing you in…</p>
    </div>
  );
};
